
import PhoneLink from './PhoneLink'

export default {
  extends: PhoneLink,
  props: {
    fax: {
      type: [Array, String],
      default: null
    }
  },
  data() {
    return {
      defaultIcon: 'print'
    }
  },
  computed: {
    value() {
      return this.fax || this.phone || this.$contact.fax
    }
  },
  methods: {
    onClick() {
      this.$tracker.trackEvent('send_fax', {
        category: 'contact',
        label: 'fax'
      })
    }
  }
}
